module.exports = __webpack_public_path__ + "img/referral-pegasus-hero.f6ef0dcf.png";